export const DownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="17"
      viewBox="0 0 7 8"
      fill="none"
    >
      <path
        d="M3.56744 0.797336C3.56744 0.682218 3.52171 0.571814 3.44031 0.490413C3.35891 0.409012 3.2485 0.363281 3.13338 0.363281C3.01827 0.363281 2.90786 0.409012 2.82646 0.490413C2.74506 0.571814 2.69933 0.682218 2.69933 0.797336V5.7826L0.989152 3.97173C0.950368 3.92891 0.903426 3.89427 0.851079 3.86983C0.798733 3.84539 0.742034 3.83164 0.684306 3.8294C0.626579 3.82716 0.568984 3.83646 0.514899 3.85676C0.460814 3.87707 0.411326 3.90796 0.369336 3.94764C0.327346 3.98732 0.2937 4.03498 0.270369 4.08783C0.247038 4.14068 0.234492 4.19766 0.233467 4.25542C0.232441 4.31318 0.242957 4.37057 0.264397 4.42421C0.285837 4.47786 0.31777 4.52669 0.358325 4.56783L2.81797 7.17216C2.85854 7.21507 2.90744 7.24925 2.96167 7.27261C3.0159 7.29597 3.07433 7.30802 3.13338 7.30802C3.19244 7.30802 3.25087 7.29597 3.3051 7.27261C3.35933 7.24925 3.40823 7.21507 3.4488 7.17216L5.90844 4.56783C5.98466 4.48368 6.02488 4.37302 6.02047 4.25958C6.01606 4.14613 5.96738 4.03892 5.88486 3.96094C5.80234 3.88297 5.69256 3.84043 5.57904 3.84244C5.46552 3.84446 5.35732 3.89087 5.27762 3.97173L3.56744 5.7826V0.797336Z"
        fill="#141414"
        fill-opacity="0.5"
      />
    </svg>
  );
};
